<template>
  <div class="element-outline">
    <template v-if="hasOutline && outline">
      <div class="group">
        <div style="flex: 2;">Border Style：</div>
        <Dropdown v-model="outline.style"
                  style="flex: 4;"
                  :options="[
                      {label: 'Solid', value: 'solid'},
                      {label: 'Dashed', value: 'dashed'}]"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select Border Style"
                  @change="updateOutline({ style: outline.style as 'dashed' | 'solid' })" />
      </div>

      <div class="group">
        <div style="flex: 2;">Border Color：</div>
        <ColorButton @click="$refs.colorPickerVisible.toggle($event)" :color="outline.color || '#000'" style="flex: 4" />
        <OverlayPanel ref="colorPickerVisible">
          <ColorPicker
              :modelValue="outline.color"
              @update:modelValue="value => updateOutline({ color: value })"
          />
        </OverlayPanel>
      </div>

      <div class="group">
        <div style="flex: 2;">Border Thickness：</div>
        <InputNumber
            v-model="outline.width"
            showButtons
            :step="1"
            style="flex: 4;"
            @change="updateOutline({ width: outline.width as number })"
        />
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import {useMainStore, useSlidesStore, useWidgetStore} from '@/store'
import { PPTElementOutline } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ColorButton from './ColorButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import {
  Switch,
} from 'ant-design-vue'
import useMicroservice from "@/hooks/useMicroservice";

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())
const { selectedWidget }  = storeToRefs(useWidgetStore())

const api = useMicroservice()

const outline = ref<PPTElementOutline>()
const hasOutline = ref(false)

watch(selectedWidget, () => {
  if (!selectedWidget.value) return
  outline.value = 'outline' in selectedWidget.value ? selectedWidget.value.outline : undefined
  hasOutline.value = !!outline.value
}, { deep: true, immediate: true })

const { addHistorySnapshot } = useHistorySnapshot()

const updateOutline = async (outlineProps: Partial<PPTElementOutline>) => {
  if (!selectedWidget.value) return
  selectedWidget.value.outline = { ...outline.value, ...outlineProps }
  await api.savePresentation()
  addHistorySnapshot()
}
</script>

<style lang="scss" scoped>
.row {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.switch-wrapper {
  text-align: right;
}

.group {
  margin-top: 25px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  column-gap: 10px;
}
</style>